import type { CommunityList, Profile } from 'models';
import { isCommunityAdminProfile, isOrganizationAdminProfile, isSuperAdmin } from './utils';

export const canManageCommunityProfile = ({ community, viewer }: { community: CommunityList; viewer: Profile }) =>
  isSuperAdmin({ viewer }) ||
  isCommunityAdminProfile({ communityId: community.id, viewer }) ||
  isOrganizationAdminProfile({ organizationId: community.organization.id, viewer });
